import React from 'react';
import PropTypes from 'prop-types';

import './IconBadge.scss';

import Icon from '../Icon';

const IconBadge = (props) => {
  const {
    background,
    size,
    bgToSvgRatio,
    height,
    width,
    ...restProps
  } = props;
  const style = {};

  if (background) {
    style.background = background;
  }

  style.height = `${height || size}px`;
  style.width = `${width || size}px`;

  /**
   * This is how I scale the icon consistently with the Badge container.
   * The ratio is for the Badge container by default be 1.5em and the icon 1em,
   * so I do the math to calculate what "1em" equals based on the provided size
   */
  style.fontSize = `${size / bgToSvgRatio}px`;

  return (
    <i className={`ResyBadge ResyBadge--${restProps.iconClass || restProps.name}`} style={style}>
      <Icon {...restProps} />
    </i>
  );
};

IconBadge.propTypes = {
  background: PropTypes.string,
  component: PropTypes.func,
  fill: PropTypes.string,
  iconClass: PropTypes.string,
  name: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  size: PropTypes.string,
  url: PropTypes.string,
  bgToSvgRatio: PropTypes.string,
};

IconBadge.defaultProps = {
  background: null,
  component: null,
  fill: null,
  iconClass: null,
  name: null,
  height: undefined,
  width: undefined,
  size: '22',
  url: null,
  bgToSvgRatio: '1.5',
};

IconBadge.displayName = 'IconBadge';
export default IconBadge;
